import { Table } from '@/components/package_asset_type/table'

interface Props {
  id: string
}

export const EditPackageAssetType = ({ id }: Props) => {
  return (
    <Table filters={ { packageIdEq: id } } createable deleteable />
  )
}
